import { Component, OnInit } from '@angular/core';
import { RoblexModalRef } from '../../config';
import { RoblexModalConfig } from '../../config/modal/modal.config';
import { ScheduleNotificationIcon } from '../../constants/schedule-notification-icon.constant';
import { RoblexModalFooterAlign } from '../../enum/modal-footer-align.enum';

@Component({
    selector: 'roblex-schedule-notifications',
    templateUrl: './schedule-notifications.component.html',
    styleUrls: ['./schedule-notifications.component.scss'],
})
export class ScheduleNotificationsComponent implements OnInit {
    /**
     * Notification  of schedule notifications component
     */
    notification!: {
        title: string;
        description: string;
        link?: string;
        image?: string;
        typeId: number;
    };
    /**
     * Modal footer align of schedule notifications component
     */
    modalFooterAlign = RoblexModalFooterAlign;
    /**
     * Creates an instance of schedule notifications component.
     * @param roblexModalConfig RoblexModalConfig
     */
    constructor(
        private roblexModalConfig: RoblexModalConfig,
        private roblexModalRef: RoblexModalRef
    ) {}
    /**
     * on init
     */
    ngOnInit(): void {
        this.notification = this.roblexModalConfig.data;
    }
    /**
     * Renders icon by type
     * @returns strign
     */
    renderIconByType() {
        return ScheduleNotificationIcon(this.notification.typeId) || '';
    }
    /**
     * Determines whether click viev on
     */
    onClickViev() {
        this.roblexModalRef.close();
        window.open(this.notification.link, '_blank');
    }
}
